import React, { useState, useEffect } from 'react';
import SessionManager from '../../routes/SessionManager';
import Loading from "../Loading";
import AppConfig from "../../config/AppConfig";
import { DatePicker, Input, Checkbox } from 'antd';
import Toastr from 'toastr';
import $ from 'jquery';
import CommonUtils from "../../util/CommonUtils";

function holidays() {

  var sessionMgr = new SessionManager();
  let user = sessionMgr.readCookie('user');

  const [holidays, setHoliday] = useState([]);
  const [holiday_date, setHolidayDate] = useState("");
  const [holiday_name, setHolidayName] = useState("");
  const [holidayFetchComplete, setHolidayFetchComplete] = useState();
  const [loading, setLoading] = useState(false);
  const [holidaysData, setHolidaysData] = useState({})

  useEffect(() => {
    getHolidaysList();
  }, [])

  const getHolidaysList = (attempts = 3) => {
    let holiday_config_data = AppConfig.getConfigParameter('holidays', 'holidays');
    let holiday_config = holiday_config_data;
    setHolidaysData(holiday_config_data);
    if (!holiday_config) {
      if (attempts > 0) {
        setTimeout(() => {
          getHolidaysList(--attempts);
        }, 3000);
      }
    } else {
      let site_id = user.site_selected.site_id;
      let holidays = [];
      for (let h of ['default', String(site_id)])
        if (holiday_config[h])
          holidays = holidays.concat(holiday_config[h].filter(x => {
            if (h !== 'default')
              x.site_level = true;
            // return x.exclude ? !x.exclude.includes(String(site_id)) : true;
            return true;
          }));

      // filtering the currYear holidays only
      let currYear = new Date().getFullYear();
      let filter_holidays = [];
      for (const holiday of holidays) {
        if (holiday.date.indexOf(currYear) !== -1) {
          filter_holidays.push(holiday);
        }
      }
      setHoliday(filter_holidays);
      setHolidayFetchComplete(true);
    }
  }

  const addHoliday = () => {
    setLoading(true);
    let holidays_Data = { ...holidaysData };
    let site_id = user.site_selected.site_id;

    if (holidays.find(holiday => holiday.date === holiday_date)) {
      Toastr.error("Holiday exists for the selected date");
      setLoading(false);
      return;
    }
    if (site_id && holidays_Data[site_id]) {
      holidays_Data[site_id].push({ date: holiday_date, name: holiday_name });
    } else {
      holidays_Data[site_id] = [{ date: holiday_date, name: holiday_name }];
    }

    let holiday = {
      config_id: "holidays",
      holidays: holidays_Data
    };

    $.ajax({
      url: "https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/common-table-operations/commonconfig/modify",
      type: "POST",
      contentType: "application/json; charset=utf-8",
      dataType: "json",
      data: JSON.stringify({
        form_input: holiday,
        "user_login": user.user_login,
        "user_token": user.user_token,
        "user_type": "user"
      }),
    }).then(
      (res) => {
        if (res.status && res.status.code === 200 && res.data) {
          setLoading(false);
          setHolidayDate("");
          setHolidayName("");
          Toastr.success("Created Successfully");
          getHolidaysList();
        } else {
          Toastr.error("Error occured");
        }
      }
    )
  }

  const deleteHoliday = (holiday) => {
    setLoading(true);
    let holidays_Data = { ...holidaysData };
    let site_id = user.site_selected.site_id;
    let holidayIndex = holidays_Data[site_id].findIndex(d => d.date === holiday.date);
    holidays_Data[site_id].splice(holidayIndex, 1);
    let holidays = {
      config_id: "holidays",
      holidays: holidays_Data
    };

    $.ajax({
      url: "https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/common-table-operations/commonconfig/modify",
      type: "POST",
      contentType: "application/json; charset=utf-8",
      dataType: "json",
      data: JSON.stringify({
        form_input: holidays,
        "user_login": user.user_login,
        "user_token": user.user_token,
        "user_type": "user"
      }),
    }).then(
      (res) => {
        if (res.status && res.status.code === 200 && res.data) {
          setLoading(false);
          Toastr.success("Deleted Successfully");
          getHolidaysList();
        } else {
          Toastr.error("Error occured");
        }
      }
    )
  }

  const excludeHoliday = (e, obj) => {
    let holidays_Data = { ...holidaysData };
    let site_id = user.site_selected.site_id;
    // console.log('h',holidays_Data);

    let defaultHolidays = [...holidays_Data.default];
    let curr_holiday_index = defaultHolidays.findIndex(d => d.date === obj.date);

    if (e.target.checked) {
      if (defaultHolidays[curr_holiday_index]['exclude'])
        defaultHolidays[curr_holiday_index]['exclude'].push(site_id);
      else
        defaultHolidays[curr_holiday_index]['exclude'] = [site_id];
    } else {
      let index = defaultHolidays[curr_holiday_index]['exclude'].indexOf(site_id);
      defaultHolidays[curr_holiday_index]['exclude'].splice(index, 1);
    }
    holidays_Data.default = defaultHolidays;

    let holidays = {
      config_id: "holidays",
      holidays: holidays_Data
    };

    $.ajax({
      url: "https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/common-table-operations/commonconfig/modify",
      type: "POST",
      contentType: "application/json; charset=utf-8",
      dataType: "json",
      data: JSON.stringify({
        form_input: holidays,
        "user_login": user.user_login,
        "user_token": user.user_token,
        "user_type": "user"
      }),
    }).then(
      (res) => {
        if (res.status && res.status.code === 200 && res.data) {
          Toastr.success("Modified Successfully");
          getHolidaysList();
        } else {
          Toastr.error("Error occured");
        }
      }
    )
  }
  return (
    <React.Fragment>
      {loading && (<div> <Loading> Saving Holidays Information ...</Loading> </div>)}
      {!loading && (
        <React.Fragment>
          <div style={{ overflowX: "auto" }}>
            <div className='mt-2'>{holidayFetchComplete !== undefined ? holidays.length === 0 ? "No holidays found..." : "" : <Loading>Fetching holidays ...</Loading>}</div>
            <table>
              {holidays && holidays.length > 0 && <thead>
                <tr>
                  <th></th>
                  <th></th>
                  <th></th>
                  {CommonUtils.hasPermission('SITESUPT-UI-MANAGE-HOLIDAYS') && <th scope="col"><u>Exclude</u></th>}
                </tr>
              </thead>}
              <tbody>
                {holidays.sort((a, b) => a.date > b.date ? 1 : a.date < b.date ? -1 : 0).map((h, i) => <tr key={'holiday_' + i}>
                  <td><b className={!h.site_level ? 'text-primary pr-2' : 'text-info pr-2'}>{h.date} : </b></td>
                  <td>{h.name}</td>
                  {CommonUtils.hasPermission('SITESUPT-UI-MANAGE-HOLIDAYS') && <td>{h.site_level ? <i className='fa ml-3 fa fa-trash-alt text-danger cursor-pointer' onClick={() => deleteHoliday(h)}></i> : ''}</td>}
                  {CommonUtils.hasPermission('SITESUPT-UI-MANAGE-HOLIDAYS') && <td style={{ textAlign: 'center' }}>{!h.site_level && <Checkbox onChange={(e) => excludeHoliday(e, h)} checked={h.exclude && h.exclude.indexOf(user.site_selected.site_id) >= 0}></Checkbox>}</td>}
                </tr>)}
                {CommonUtils.hasPermission('SITESUPT-UI-MANAGE-HOLIDAYS') &&
                  <tr>
                    <td width="150" style={{ paddingTop: "16px" }}>
                      <DatePicker
                        placeholder="Select Date"
                        allowClear={true}
                        format={'YYYY-MM-DD'}
                        showToday={false}
                        style={{ 'width': '120px', 'height': '30px' }}
                        className="form-control required"
                        onChange={(date, dateString) => setHolidayDate(dateString)}
                      />
                    </td>
                    <td style={{ paddingTop: "16px" }}>
                      <Input
                        placeholder="New Holiday Name"
                        type="name"
                        name="holiday_name"
                        className="form-control required"
                        onChange={(e) => setHolidayName(e.target.value)}
                        autoComplete='off'
                        style={{ 'width': '150px', 'height': '30px' }}
                      />
                    </td>
                    <td style={{ paddingTop: "16px" }}>
                      <button
                        className='btn btn-sm btn-primary ml-1'
                        onClick={() => addHoliday()}
                        disabled={!(holiday_date && holiday_name.trim())}
                      >
                        Add
                      </button>
                    </td>
                  </tr>}
              </tbody>
            </table>
          </div>
        </React.Fragment>
      )
      }
    </React.Fragment>
  )

}

export default holidays;